module.exports = __webpack_public_path__ + "img/info-2.214fb2d6.svg";